import { EventingHelpers } from '@app/common/src/hooks/useLocalEventing/useLocalEventing'
import { TimestampEvents, useTimestampTracking } from './useTimestampTracking'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'
import { useEffect } from 'react'
import { useSendWelcomeToastEvent } from './useSendWelcomeToastEvent'

export interface UseConfigureSessionHelpers {
  addEventHandler: EventingHelpers<TimestampEvents>['addEventHandler']
  removeEventHandler: EventingHelpers<TimestampEvents>['removeEventHandler']
}

interface EventsToRemove {
  onTimestampChange: TimestampEvents['onTimestampChange'][]
}

export const useConfigureSession = (): UseConfigureSessionHelpers => {
  const { addEventHandler, removeEventHandler } = useTimestampTracking()
  const { hasOperation } = useAuthState()
  const { sendWelcomeToastEvent } = useSendWelcomeToastEvent()

  useEffect(() => {
    const eventsToRemove: EventsToRemove = {
      onTimestampChange: []
    }

    if (hasOperation('view:analytics_welcome_toast')) {
      addEventHandler('onTimestampChange', sendWelcomeToastEvent)

      eventsToRemove.onTimestampChange.push(sendWelcomeToastEvent)
    }

    const removeEvents = (): void => {
      for (const key in eventsToRemove) {
        eventsToRemove[key as keyof EventsToRemove].forEach(eventHandler =>
          removeEventHandler(key as keyof EventsToRemove, eventHandler)
        )
      }
    }

    return removeEvents
  }, [sendWelcomeToastEvent, addEventHandler, removeEventHandler, hasOperation])

  return { addEventHandler, removeEventHandler }
}
